import { render, staticRenderFns } from "./route-target.vue?vue&type=template&id=5439e75c&scoped=true&"
import script from "./route-target.vue?vue&type=script&lang=js&"
export * from "./route-target.vue?vue&type=script&lang=js&"
import style0 from "./route-target.vue?vue&type=style&index=0&id=5439e75c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5439e75c",
  null
  
)

export default component.exports